import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import registerServiceWorker from 'react-service-worker';

import { BrowserRouter, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";

import { configureStore } from "./store";
import AppThemeProvider from "./Components/Common/AppTheme";
//test1
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore({})}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <AppThemeProvider>
          <App />
        </AppThemeProvider>
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

reportWebVitals();
